import { http } from './http'
import { auth } from './auth'
import { MarkupSchema, type CreateMarkupPayload } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'
import z from 'zod'

const MarkupResponseSchema = z.object({
  markup: MarkupSchema,
})

export const markups = {
  create: async (payload: CreateMarkupPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/markups`, { markup: payload }, dealId)
    return parseWithZod(MarkupResponseSchema, result).markup
  },
}
